module.exports = __webpack_public_path__ + "img/voice_desktop.24fe3587.svg";